import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { LoadingProgressBar } from "@rentablo/components";
import { createAndRedirectToTppWebForm } from "@rentablo/bank-import";
import { SomethingWrong } from "@components";
import { buildReturnUrl } from "./buildReturnUrl";
import { WebFormEntry } from "./webFormEntries";

export const TppWebFormLauncher = ({ entry }: { entry: WebFormEntry }) => {
  const navigate = useNavigate();
  const hasStarted = useRef(false);
  const { mutate, error } = useMutation({
    mutationFn: () =>
      createAndRedirectToTppWebForm({
        ...entry.request,
        redirectUrl: buildReturnUrl(entry.returnTo),
      }),
  });

  // Every call creates a web form on the backend, so StrictMode's second
  // mount must not make another.
  useEffect(() => {
    if (hasStarted.current) return;
    hasStarted.current = true;
    mutate();
  }, [mutate]);

  if (error) {
    return (
      <SomethingWrong
        error={error}
        onClose={() => navigate(entry.returnTo, { replace: true })}
      />
    );
  }

  return <LoadingProgressBar />;
};
